import CalendarEventPreview from './CalendarEventPreview';

export default CalendarEventPreview;